import { render, staticRenderFns } from "./PageMarket.vue?vue&type=template&id=0ec4ce10&lang=pug"
import script from "./PageMarket.vue?vue&type=script&lang=js"
export * from "./PageMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports